import styled from 'styled-components';

export const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 15px;
  cursor: pointer;

  & > button {
    padding: 8px;
    border-radius: 50%;
    background-color: rgb(102, 102, 102);
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);

    & > svg {
      fill: #fff;
    }
  }
`;
